import { useFormContext } from 'react-hook-form'

import { ImageComponent } from '@apps-common/components/common'
import { ButtonCopy, InputInfoSM } from '@apps-common/components/elements'
import { IActivationServiceRequestCreateModel } from '@apps-common/types/portal/service-request'

interface IProps {
  loading?: boolean
  updating?: boolean
}

export const ActivationUnitView: React.FC<IProps> = ({ loading, updating }) => {
  const { getValues } = useFormContext<IActivationServiceRequestCreateModel>()

  const { productImageUrl, serialNo, imei, useLineSupervision } = getValues()

  return (
    <InputInfoSM
      id='unit'
      hideNoEditIcon
      showLabel
      label='Device to activate'
      value={
        <>
          {loading && (
            <div className='relative min-w-[140px] rounded-3xl text-[0.9em] px-5 py-4 text-left bg-skeleton border border-skeleton-border animate-pulse'>
              <div className='flex items-center justify-start grow gap-[10px]'>
                <div className='min-w-[50px] min-h-[50px] rounded-full p-[5px] bg-skeleton-hi border border-border flex items-center justify-center' />
                <div className='flex flex-col gap-[6px] text-[0.9em] leading-[1.2em] w-full'>
                  <div className='w-[60%] h-[12px] bg-skeleton-hi rounded' />
                  <div className='w-[60%] h-[12px] bg-skeleton-hi rounded' />
                  <div className='w-[60%] h-[12px] bg-skeleton-hi rounded' />
                </div>
              </div>
            </div>
          )}
          {!loading && (
            <div className='relative min-w-[140px] rounded-3xl text-[0.9em] px-5 py-4 text-left bg-surface-2 border border-border'>
              <div className='flex items-center justify-between'>
                <div className='flex flex-col items-start justify-around gap-[15px]'>
                  <div className='flex items-center justify-start grow gap-[10px]'>
                    <div className='w-[50px] h-[50px] rounded-[25px] p-[5px] bg-surface border border-border flex items-center justify-center'>
                      <ImageComponent src={productImageUrl} alt='Product' imageClasses='max-w-[80%]' errorIconClasses='text-[1.5rem]' />
                    </div>
                    <div className='flex flex-col gap-[6px] text-[0.9em] leading-[1.2em]'>
                      <div className='flex'>
                        <span className='bg-surface-2 text-text px-1 rounded-[5px] mr-[2px]'>SerialNo</span>
                        <span className='jost-medium'>
                          <ButtonCopy value={serialNo} showValue iconClassName='text-[1.1em]' />
                        </span>
                      </div>
                      <div className='flex'>
                        <span className='bg-surface-2 text-text px-1 rounded-[5px] mr-[2px]'>IMEI</span>
                        <span className='jost-medium'>
                          <ButtonCopy value={imei} showValue iconClassName='text-[1.1em]' />
                        </span>
                      </div>
                      <div className='flex'>
                        <span className='bg-surface-2 text-text px-1 rounded-[5px] mr-[2px]'>Line supervision</span>
                        <span className='jost-medium'>{useLineSupervision ? 'Enabled' : 'Disabled'}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      }
      className='border-none !p-0 !opacity-100 !min-h-[86px]'
    />
  )
}
